import React from 'react';
import styled from 'styled-components';

const VariationText = ({ isAvailableOffer, textLabel, typeLabel, typeId, isSkuTypeSize }) => (
  <Wrapper>
    {isAvailableOffer ? (
      <>
        {textLabel}:&nbsp;
        <TypeLabel $isSkuTypeSize={isSkuTypeSize} $isAvailableOffer={isAvailableOffer}>
          {typeLabel}
        </TypeLabel>
      </>
    ) : (
      <UnavailableVariation>
        {typeId}
        <TypeLabel $isSkuTypeSize={isSkuTypeSize} $isAvailableOffer={isAvailableOffer}>
          {typeLabel ? ` ${typeLabel} ` : ' '}
        </TypeLabel>
        indisponível
      </UnavailableVariation>
    )}
  </Wrapper>
);

const TypeLabel = styled.strong`
  font-weight: ${({ $isAvailableOffer }) => ($isAvailableOffer ? 'bold' : 'normal')};
  text-transform: ${({ theme, $isSkuTypeSize }) => ($isSkuTypeSize ? 'uppercase' : theme.titleTransform)};
`;

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const UnavailableVariation = styled.div`
  color: red;
`;

export default VariationText;
